<template name="checkPageList">
  <div>
    <div class="info-card">
      <span class="title-style">未发布程序管理</span>
    </div>

    <!-- 搜索部分 -->
    <div style="display: flex;justify-content: center;">
      <el-input style="width: 60%;margin-right: 10px"
                placeholder="输入程序名称"
                v-model="searchTitle" @clear="clear"
                clearable>
      </el-input>
      <el-button icon="el-icon-search" circle @click="getProgramList"></el-button>
    </div>

    <div style="margin-top: 10px;">
      <el-table :data="programList" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
                :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
        <el-table-column prop="id" label="id" width="85" show-overflow-tooltip align="center"/>
        <el-table-column prop="programName" label="程序名称" width="300" show-overflow-tooltip align="center"/>
        <el-table-column prop="description" label="程序描述" width="300" show-overflow-tooltip align="center"/>
        <el-table-column label="程序类型" width="300" show-overflow-tooltip align="center">
          <template v-slot="scope">
            <div v-if="scope.row.programType == 0">梯形图</div>
            <div v-if="scope.row.programType == 1">C语言</div>
            <div v-if="scope.row.programType == 2">Python语言</div>
          </template>
        </el-table-column>
        <el-table-column  label="设计" min-width="110" show-overflow-tooltip align="center">
          <template v-slot="scope">
            <el-button icon="el-icon-s-promotion" type="primary" circle @click="design(scope.row)"></el-button>
          </template>
        </el-table-column>
        <el-table-column label="修改" min-width="110" show-overflow-tooltip align="center">
          <template v-slot="scope">
            <el-button icon="el-icon-edit" type="primary" circle @click="handleEditIdBtnClick(scope.row)"></el-button>
          </template>
        </el-table-column>
        <el-table-column label="发布" min-width="110" show-overflow-tooltip align="center">
          <template v-slot="scope">
            <el-button icon="el-icon-upload" type="success" circle @click="publishProgram(scope.row)"></el-button>
          </template>
        </el-table-column>
        <el-table-column label="删除" min-width="110" align="center">
          <template v-slot="scope">
            <el-button type='danger' icon="el-icon-document-delete" circle @click="deleteProduct(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="修改页面名称" :visible.sync="show">
      <el-form>
        <el-form-item label="页面名称" label-width="120px">
          <el-input v-model="tempTitle" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="页面描述" label-width="120px">
          <el-input v-model="tempDescription" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show=false">取 消</el-button>
        <el-button type="primary" @click="show=false;handleConfirmBtnClick();">确 定</el-button>
      </div>
    </el-dialog>

    <!--选择发布设备页面-->
    <el-dialog title="请选择发布的设备" width="30%" :visible.sync="publishProductDialogVisible">
      <el-select v-model="deviceId" clearable placeholder="请选择">
        <el-option
            v-for="item in deviceList"
            :key="item.id"
            :label="item.deviceName"
            :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="publishProductDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="handlePublishProgram">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="确认删除页面？" :visible.sync="deleteProductDialogVisible">
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteProductDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="handleDeleteProduct">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/../config/api.js";
import IMGURL from "@/../config/imgUrl.js";
export default {
  name: "checkProgramList",
  data() {
    return {
      programList: [],
      pages: '',
      pageNum: 1,
      userId: '',
      logoProduct: IMGURL.logoProduct, //logo图片
      logoCheck: IMGURL.logoCheck, //logo图片
      logoLaunch: IMGURL.logoLaunch, //logo图片
      customStyle: {
        color: '#3399ff',
      },
      customStyle3: {
        color: '#55aa00',
      },
      customStyle4: {
        color: '#aa55ff',
      },
      deviceList:[],    // 设备信息
      deviceId: '',      // 选择的设备id
      show: false, //修改页面名字和描述
      tempTitle: '', //记录修改框里出现的名称，传入后端
      tempProductId: 0,
      tempDescription: '', //记录修改框里出现的描述，传入后端
      tempProgramType:'',
      searchTitle: '', //程序搜索的名字内容
      publishProductDialogVisible: false,//发布页面对话框
      publishProductItem: {},
      deleteProductDialogVisible: false,//删除页面对话框
      deleteProductItem: {},
    }
  },
  props: {
    companyId: Number,
    projectId: Number,
  },
  mounted() {
    this.getProgramList();
    this.getDeviceList();
    this.userId = window.localStorage.getItem('userid');
  },

  methods: {
    // 获得设备列表
    getDeviceList() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
      }
      this.$axiosRequest({
        url: API.getDeviceList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.deviceList = res.data['deviceList']
        }
      });
    },
    //修改页面名字
    handleEditIdBtnClick(item) {
      console.log(item)
      this.show = true
      this.tempTitle = item.programName;
      this.tempDescription = item.description;
      this.tempProgramId = item.id;
      this.tempProgramType = item.programType;
      console.log('this.tempProgramId', this.tempProgramId)
    },

    //修改页面名字与后端
    // async
    handleConfirmBtnClick() {
      console.log('this.tempProgramId', this.tempProgramId)
      if (!this.tempTitle) {
        this.$message({
          message: '程序名不能为空',
          type: 'warning'
        })
        this.show = false
        return
      }
      // if (!this.tempDescription) {
      //   this.$message({
      //     message: '程序描述不能为空',
      //     type: 'warning'
      //   })
      //   this.show = false
      //   return
      // }
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
        id: this.tempProgramId,
        programName: this.tempTitle,
        programType:this.tempProgramType,
        description: this.tempDescription
      }
      this.$axiosRequest({
        url: API.updatePLC,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data > 0) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.show = false
            for (let i = 0; i < this.programList.length; i++) {
              if (this.programList[i].id == this.tempProgramId) {
                this.programList[i].programName = this.tempTitle
                this.programList[i].description = this.tempDescription
                break;
              }
            }
            this.$emit('changeName', this.tempTitle, this.tempProgramId) //向外抛出修改名字的事件
          } else if (res.data == 0) {
            this.$message({
              message: '标题已经存在',
              type: 'warning'
            });
            this.show = false
            return
          } else if (res.data == -2) {
            this.$message({
              message: '参数错误',
              type: 'warning'
            });
            this.show = false
            return
          } else if (res.data == -1) {
            this.$message({
              message: '保存出错',
              type: 'warning'
            });
            this.show = false
            return
          }

        }
      });
    },
    //直接跳转设计的页面
    design(item){
      this.$emit('design',item)
    },
    //发布页面
    publishProgram(item){
      this.publishProductItem = item;
      this.publishProductDialogVisible = true;
    },

    //发布 已经调通
    handlePublishProgram() {
      let item = this.publishProductItem;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded",
      }
      let data = {
        id: item.id,
        companyId: this.companyId,
        device_id:this.deviceId,
      }
      this.$axiosRequest({
        url: API.publishPLC,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          let data = res.data;
          if (data > 0) {
            this.$message({
              message: '发布成功！',
              type: 'success',
            })
            this.publishProductDialogVisible = false;
            this.getProgramList()
          } else if (data === -3) {
            this.$message({
              message: '程序未编译成功！',
              type: 'error',
            })
          } else if (data === -2) {
            this.$message({
              message: '参数不完整！',
              type: 'error',
            })
          } else if (data === -1) {
            this.$message({
              message: '执行出错！',
              type: 'error',
            })
          }
        }

      });
    },
    //调通
    getProgramList() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded",
      }

      let data = {
        companyId: this.companyId,
        programName: this.searchTitle,
        publish_status: 0, //后面打开代表未发布的页面

      }
      this.$axiosRequest({
        url: API.getPLCList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log('第一页', res.data["plcList"])
          this.programList = res.data["plcList"];
          console.log(this.plcListList)
        }
      });

    },
    //清空页面名称搜索框
    clear() {
      this.programList.length = 0; //重新刷新一下    //先把列表清空
      this.getProgramList();
    },
    deleteProduct(item){
      this.deleteProductItem = item;
      this.deleteProductDialogVisible = true;
    },
    //删除页面 已经调通与树连接可以
    handleDeleteProduct() {
      let item = this.deleteProductItem;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded",
      }
      let data = {
        companyId: this.companyId,
        id: item.id,
      }
      this.$axiosRequest({
        url: API.deletePLC,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data.flag == "true") {
            this.$message({
              message: res.data.info,
              type: 'success'
            });
            this.deleteProductDialogVisible = false;
            this.getProgramList()
            //后期根据接口重新修改，要打开
            let delChild = {
              label: item.programName,
              stageType: 7,
              id: item.id,
              uniqueId: 'PLC_' + item.id
            };
            this.$emit('delete', delChild);
          } else if (res.data.flag == "false") {
            this.$message({
              message: res.data.info,
              type: 'warning'
            });
          }

        }
      });


    },
  }

}
</script>

<style>
.info-card {
  margin: 10px 15px 10px 15px;
  padding: 12px;
}
.title-style {
  font-size: 18px;
  font-weight: bold;
}
</style>
